import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import BannerCarousel from "@/components/BannerCarousel";
import ProductCard from "@/components/ProductCard";

const Row = ({ title, products, cta }) => {
  if (products.length === 0) return null;
  return (
  <div className="bg-white rounded-sm fk-shadow" data-testid={`row-${title.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="flex items-center justify-between px-4 py-3 border-b border-[#f0f0f0]">
      <h2 className="font-head text-lg sm:text-xl font-bold text-[#212121]">{title}</h2>
      {cta && (
        <Link
          to={cta}
          className="bg-[#C62828] text-white text-xs font-semibold px-4 py-2 rounded-sm hover:bg-[#A01F1F] transition-colors"
        >
          VIEW ALL
        </Link>
      )}
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-px bg-[#f0f0f0]">
      {products.map((p) => (
        <div key={p.id} className="bg-white">
          <ProductCard product={p} />
        </div>
      ))}
    </div>
  </div>
  );
};

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/products").then((r) => {
      setProducts(r.data.products);
      setLoading(false);
    });
  }, []);

  const byCat = (c) => products.filter((p) => p.category === c);
  const deals = [...products].sort((a, b) => b.discount_pct - a.discount_pct).slice(0, 6);

  return (
    <main className="max-w-[1400px] mx-auto px-2 sm:px-4 py-3 space-y-3 fk-fade-up">
      <BannerCarousel />

      {loading ? (
        <div className="py-20 text-center text-[#878787]">Loading products…</div>
      ) : (
        <>
          <Row title="Deals of the Day" products={deals} />
          <Row title="Statues & Idols" products={byCat("Statues")} cta="/category/Statues" />
          <Row title="Divine Brass & Home Decor" products={byCat("Home Decor")} cta="/category/Home Decor" />
          <Row title="Studio Pottery & Ceramics" products={byCat("Pottery & Ceramics")} cta="/category/Pottery & Ceramics" />
          <Row title="Handloom Textiles" products={byCat("Textiles")} cta="/category/Textiles" />
          <Row title="Heritage Wood Craft" products={byCat("Wood Craft")} cta="/category/Wood Craft" />
          <Row title="Handmade Jewellery" products={byCat("Jewellery")} cta="/category/Jewellery" />
          <Row title="Folk Wall Art" products={byCat("Wall Art")} cta="/category/Wall Art" />
        </>
      )}
    </main>
  );
};

export default Home;
